import React from 'react';
import { CheckCircleFilled } from '@ant-design/icons';
import { Text } from '@clockout-dev/design-elements';
import styles from '../styles/account.module.scss';

/**
 * Success banner rendered above the form after a save. Returns `null` when
 * no message is supplied so the orchestrator can pass `successMessage`
 * unconditionally without rendering an empty wrapper.
 */
function AccountSuccessBanner({ message }) {
    if (!message) return null;

    return (
        <div className={styles.successBanner} role="status" aria-live="polite">
            <CheckCircleFilled className={styles.successBannerIcon} aria-hidden="true" />
            <Text as="span" size="s" className={styles.successBannerText}>
                {message}
            </Text>
        </div>
    );
}

export default AccountSuccessBanner;
